export const getReportNames = () => ([
  {
    key: 'weekly_provider_actuation_summary',
    name: 'Provider Actuation (Weekly Summary)',
    // Component: WeeklyProviderActuationSummaryReport,
  },
]);

export const getReportFilterSettings = (reportName, options = {}) => {
  switch (reportName) {
    case 'weekly_provider_actuation_summary':
      return [
        {
          name: 'id',
          label: 'Provider',
          type: 'selectProvider',
          required: false,
          fullWidth: true,
          maxWidth: '300px',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          name: 'team_id',
          label: 'Team',
          type: 'selectTeam',
          required: false,
          fullWidth: true,
          maxWidth: '300px',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          name: 'team__market_id',
          label: 'Market',
          type: 'selectMarket',
          required: false,
          fullWidth: true,
          maxWidth: '300px',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          name: 'team__market__region_id',
          label: 'Region',
          type: 'selectRegion',
          required: false,
          fullWidth: true,
          maxWidth: '300px',
          grid: {
            xs: 12,
            md: 6,
          },
        }
      ];
    default:
      return [];
  }
};